import { BiotechOutlined, History } from "@mui/icons-material";
import { Button, Chip, Typography } from "@mui/material";
import { ServiceRequestActions } from "../../ServiceRequest/ServiceRequestAction";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { EhrResponsiveTable } from "../../../mobile/EhrResponsiveTable";
import { useDocumentHistoryColumn } from "./useDocumentHistoryColumn";

/** Data mais recente do documento (pipeline paciente só tem `date`). */
function latestDocDate(row: any): string {
  return row.lastDate || row.date || row.firstDate || "—";
}

export function Solicitations({
  rowData = [],
  resultsData,
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
  onPrepareReissue,
  /** Visão paciente: uma coluna "Data" (mais recente), sem Emitido em / reemissão / histórico. */
  patientView = false,
}: any) {
  const { displayRows, historyDialog, openHistory, rowHasHistory } =
    useDocumentHistoryColumn({
      rowData,
      handleOpen,
      setBinaryUrl,
    });

  const columns = patientView
    ? [
        {
          column: "Descrição",
          rowName: "description",
          width: "28%",
          lineClamp: 2,
        },
        { column: "Emitido em", rowName: "firstDate", width: "14%" },
        { column: "Categoria", rowName: "category", width: "18%" },
        {
          column: "Profissional",
          rowName: "practitioner",
          width: "20%",
          lineClamp: 1,
        },
      ]
    : [
        {
          column: "Descrição",
          rowName: "description",
          width: "22%",
          lineClamp: 2,
        },
        { column: "Emitido em", rowName: "firstDate", width: "12%" },
        { column: "Última reemissão", rowName: "lastDateCell", width: "14%" },
        { column: "Histórico", rowName: "historyAction", width: "12%" },
        { column: "Categoria", rowName: "category", width: "14%" },
        {
          column: "Profissional",
          rowName: "practitioner",
          width: "16%",
          lineClamp: 1,
        },
      ];

  const tableRows = patientView
    ? (rowData || []).map((row: any) => ({
        ...row,
        firstDate: latestDocDate(row),
        date: latestDocDate(row),
      }))
    : displayRows;

  return (
    <>
      <EhrResponsiveTable
        title="Solicitações de exame"
        hideSectionHeader
        columns={columns}
        rows={tableRows}
        actions={(row: any) => (
          <ServiceRequestActions
            setRefetch={setRefetch}
            row={row}
            handleOpen={handleOpen}
            setBinaryUrl={setBinaryUrl}
            onPrepareReissue={onPrepareReissue}
          />
        )}
        renderCard={(row: any) =>
          patientView ? (
            <DocumentCard
              key={row.id ?? row.description}
              title={row.description || "Solicitação de Exame"}
              date={latestDocDate(row)}
              dateLabel="Emitido em"
              practitioner={row.practitioner}
              specialty={row.specialty}
              status={{
                text: row.category,
                color: "#2196F3",
                icon: <BiotechOutlined />,
              }}
              actions={
                <ServiceRequestActions
                  setRefetch={setRefetch}
                  row={row}
                  handleOpen={handleOpen}
                  setBinaryUrl={setBinaryUrl}
                  onPrepareReissue={onPrepareReissue}
                />
              }
            >
              {row.resultUrls && row.resultUrls.length > 0 ? (
                <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                  {row.resultUrls.length > 1
                    ? `${row.resultUrls.length} resultados disponíveis`
                    : "Resultado disponível"}
                </Typography>
              ) : null}
            </DocumentCard>
          ) : (
            <DocumentCard
              key={row.id ?? row.description}
              title={row.description || "Solicitação de Exame"}
              date={row.firstDate || row.date}
              dateLabel="Emitido em"
              lastDate={rowHasHistory(row) ? row.lastDate : undefined}
              singleIssue={!rowHasHistory(row)}
              practitioner={row.practitioner}
              specialty={row.specialty}
              status={{
                text: row.category,
                color: "#2196F3",
                icon: <BiotechOutlined />,
              }}
              actions={
                <ServiceRequestActions
                  setRefetch={setRefetch}
                  row={row}
                  handleOpen={handleOpen}
                  setBinaryUrl={setBinaryUrl}
                  onPrepareReissue={onPrepareReissue}
                />
              }
            >
              {row.resultUrls && row.resultUrls.length > 0 ? (
                <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                  {row.resultUrls.length > 1
                    ? `${row.resultUrls.length} resultados disponíveis`
                    : "Resultado disponível"}
                </Typography>
              ) : null}
              {rowHasHistory(row) ? (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<History />}
                  onClick={() => openHistory(row)}
                  sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  Histórico
                </Button>
              ) : (
                <Chip
                  label="Emissão única"
                  variant="outlined"
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                    borderColor: "divider",
                  }}
                />
              )}
            </DocumentCard>
          )
        }
      />
      {!patientView ? historyDialog : null}
    </>
  );
}
